import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { SharedDataService } from '../../services/shared-data.service';
import lifeProductType from '../../life-config/productCodeConfig.json';
import productConfig from '../../life-config/productCodeConfig.json';


import { DialogData, RadioEventData } from '../../model/data.model';

import lifeProposalJson from '../../life-config/lifeQuotesConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';


@Component({
    selector: 'app-edit-propsoal-modal',
    templateUrl: './edit-propsoal-modal.component.html',
    styleUrls: ['./edit-propsoal-modal.component.css']
})
export class EditPropsoalModalComponent implements OnInit {

    editProposal: FormGroup;
    addRiderDetails: FormArray;
    radioEventData: RadioEventData;
    uuid: string;
    proposalId: string;
    // Remove any later - Use Interface / class
    // on getting finla UI add to class
    editProposalModalJson: any = lifeProposalJson.editModalInitialJson;
    lifeQuoteConfigList: any = lifeQuoteJson.editModalInitialJson;
    productConf = productConfig.product_type;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    productType: object = lifeProductType.componentClassName;
    editModalConfData: object;
    inputValueFromCmp: number | string;
    calValFromCmp: object;
    annualIncomeInComma: any;
    numberInWords: any;
    annualIncomeData: any;
    sumAssuredValue: any;
    policyList: any = [];
    dobCal: any;
    mergedObject: any;
    savingFrequencyList: any;

    // Unable to add private class
    editPropsalModalResp: any;
    destroySubject$: Subject<void> = new Subject();
    isCoverageAgeError = true;
    isCoverAgeErrorTxt: string;
    isSumAssuredErrorTxt: string;
    isDisplayedError: boolean;
    error: Array<any> = [];
    isLoaderActivated = false;
    editQuoteMaxDate: any;
    minAge: any;
    currentDate: any;
    year: any;
    month: any;
    day: any;
    limitedPayList: any;
    quotesInitialInfo: any;
    policyTermRes: any;
    wholeLifeBoolean: any;
    premiumTermVal: any;
    premiumPPtType: any;
    riderSumAssuredList = [];
    riderId = {};
    isLoaderinActiveState = {};
    premiumPaymentTypeToSend: any;
    isSumInsuredError = false;
    isDisable = {};
    errorStatus: any;
    premiumAmountVal: any;
    pptList: any;
    savingPolicyList: any;
    frequencyType: any;


    constructor(

        private dialogRef: MatDialogRef<EditPropsoalModalComponent>,
        private formbuild: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private sharedData: SharedApiService,
        private datePipe: DatePipe,
        private sharedDataService: SharedDataService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {

        /**
         * Preventing model on esc and mouse click
         */

        dialogRef.disableClose = true;
        // Initilaizing form

        this.editProposal = this.formbuild.group({
            withdrawFor:[''],
            payFor:[''],
            premiumAmnt: [''],
            dob: ['', Validators.required],
            annualIncome: ['', [Validators.required, Validators.pattern(new RegExp('^[0-9,]*$'))]],
            sumAssured: ['', Validators.required],
            policyTerm: ['', Validators.required],
            paymentFrequency: [''],
            payTillAge: [this.editProposalModalJson['payTillAge']['default']],
            addRiderDetails: new FormArray([this.createRiderCtrl()])

        });


        /**
         * Loader status
         */

        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];
                this.errorStatus = errorStatusFromApi;

                if (errorStatusFromApi === 400 || errorStatusFromApi === 500) {

                    this.isLoaderinActiveState = false;
                    this.getLoaderStatus();

                }
            }


        });

        this.quotesInitialInfo = data['editProposalModal'];
        if (this.quotesInitialInfo &&  this.quotesInitialInfo['available_plans_set'] && this.quotesInitialInfo['available_plans_set']['withdraw_after']){

            this.savingPolicyList = this.quotesInitialInfo['available_plans_set']['withdraw_after'];
        }

        if (this.quotesInitialInfo &&  this.quotesInitialInfo['available_plans_set'] && this.quotesInitialInfo['available_plans_set']['pay_for']){

            this.pptList = this.quotesInitialInfo['available_plans_set']['pay_for'];
        }


        this.dobCal = data['editProposalModal']['lifeassured']['dob'];
        this.minAge = 18;
        this.currentDate = new Date();
        this.year = this.currentDate.getFullYear();
        this.month = this.currentDate.getMonth();
        this.day = this.currentDate.getDate();
        this.editQuoteMaxDate = new Date(this.year - this.minAge, this.month, this.day);
        this.limitedPayList = this.quotesInitialInfo['available_plans_set'];
        this.savingFrequencyList = this.quotesInitialInfo['available_premium_instalment_type'];
        this.savingFrequencyList.forEach(element => {

            if (this.quotesInitialInfo['premium_installment_type'] === element['value']) {

                this.frequencyType = element['ui_name']
                this.editProposal.patchValue({ paymentFrequency: element['value'] });
            }
        });
        /**
         * this dob data will be shared only it has been changed from user
         * Without unsuccessful waiting of respose
         * As BE required dob value to validate for coverage age
         */

        if (data['onUIChange']) {
            this.dobCal = data['onUIChange'];

        }

        /**
         * making modal understand that need to dispaly in modal error
         */
        this.apiService.setModalInfo(true);

        // Getting DOB to calulate premium
        // Is it ok to put it in  cinstructor instance as we required date
        /**
         * Adding Dob field and patching it
         */

        this.editProposal.patchValue({ dob: data['editProposalModal']['lifeassured']['dob'] });
        this.editProposal.patchValue({ annualIncome: data['editProposalModal']['lifeassured']['annual_income'] });


        if (this.quotesInitialInfo['product_type'] === this.productConf['termProductType']) {

            this.setPayTillAge();
            this.getRiderFormControl();
            this.getRiderInfo();


        }

        if (this.quotesInitialInfo['product_type'] === this.productConf['savingProductType']) {

            this.editProposal.patchValue({ payFor: data['editProposalModal']['premium_term'] });
            this.editProposal.patchValue({ withdrawFor: data['editProposalModal']['policy_term'] });
            this.editProposal.patchValue({ premiumAmnt: data['editProposalModal']['base_premium'] });
            this.getRiderFormControl();
            this.getRiderInfo();

        }



        /**
         * End of new field
         */
        this.iteratedValue(data['editProposalModal']['lifeassured']['dob']);

        // Updating value as per api recieve info
        this.editProposal.patchValue({ sumAssured: data['editProposalModal']['sum_assured'] });
        if (data['editProposalModal']['coverage_age'] && !data['editProposalModal']['whole_life_opted']) {
            this.editProposal.patchValue({ policyTerm: data['editProposalModal']['coverage_age'] });
        }

        if (data['editProposalModal']['whole_life_opted']) {
            this.editProposal.patchValue({ policyTerm: 'Whole life' });
        }

        if (  this.quotesInitialInfo['opted_rider'] && this.quotesInitialInfo['opted_rider'].length > 0){
            this.setOptedRider();
        }


        // if (data['editProposalModal']['policy_term']) {
        //     // Add age + poliy term to display
        //     const dobReceived = data['editProposalModal']['lifeassured']['dob'];
        //     const ageObtained = this.sharedData.getAgeInyears(new Date(dobReceived));
        //     const policyTermtoShow = ageObtained + data['editProposalModal']['policy_term'];
        //     this.editProposal.patchValue({ policyTerm: policyTermtoShow });
        // }


        // Retreiving query parms and modify to addrss bar <--- Remove this it is iterated
        this.uuid = data['uuid'],
        this.proposalId = data['proposalId'];


        this.apiService.getStatusEvent.subscribe(value => {

            if (value) {
                const errorStatusFromApi = value['status'];

                if (errorStatusFromApi === 400) {

                    this.isCoverageAgeError = false;
                    this.isDisplayedError = true;
                    this.isLoaderActivated = false;
                    // this.isCoverAgeErrorTxt = value['error']['dob'];
                    this.create_display_msg('Error', value['error']);


                }
            }


        });

    }

    getLoaderStatus() {

        let riderDataInfo = this.sharedDataService.riderData;
        if (this.quotesInitialInfo['config']['rider_config'] && this.quotesInitialInfo['config']['rider_config'].length > 0) {

            this.quotesInitialInfo['config']['rider_config'].forEach((riderElement, riderIndex) => {



                // if (this.quotesInitialInfo && this.quotesInitialInfo['opted_rider'].length > 0) {

                    // this.quotesInitialInfo['opted_rider'].forEach((optedElement, optedRiderIndex) => {

                        if (riderElement['rider_code'] === riderDataInfo['rider_code']) {

                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                        }

                    // });

                // }
                // else {

                //     this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
                //     this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;

                // }

                // this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
                // this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                // this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;

            });
        }






    }

    /**
     * Erorr to show in html
     */
    create_display_msg(key: string, massege: any) {
        this.error = [];
        if (typeof massege === 'object') {
            if (massege instanceof Array) {
                this.create_display_msg(key, massege[0]);
            } else {
                // tslint:disable-next-line: forin
                for (const keys in massege) {
                    this.create_display_msg(keys, massege[keys]);
                }
            }
        } else {
            this.error.push({ key, msg: massege });
        }
    }

    // Itertaion  for pay for from 85- birthdate

    iteratedValue(dob) {
        if (dob !== undefined) {
            const ageObtained = this.sharedData.getAgeInyears(new Date(dob));
            const ageTillIteration = 85;

            /**
             * Iteration for coverage up to
             */
            for (let policyIteration = 5 + ageObtained; policyIteration <= ageTillIteration; policyIteration++) {
                this.policyList.push({ id: policyIteration, value: policyIteration });
            }
            const wholeLifevalue = 'Whole life';
            this.policyList.push({ id: wholeLifevalue, value: wholeLifevalue });
        }

    }



    /**
     * Coverage till age
     */

    policyTermInvoked() {

        const policyTermUrl = this.apiUrl['apiV2LifeProposal'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['update_proposal'];
        const ageObtained = this.sharedData.getAgeInyears(new Date(this.quotesInitialInfo['lifeassured']['dob']));
        // const wholeLifeBoolean = this.quotesInitialInfo['whole_life_opted'];

        // const policyValObtained = this.editProposal.get('policyTerm').value - ageObtained;

        /**
         * check value has whole life
         */


        if (this.editProposal.get('policyTerm').value === this.editProposalModalJson['whole-life']) {
            /**
             * check for undefined value
             */
            this.setPayTillAge();
            if (this.editProposal.get('payTillAge').value) {

                this.premiumPPtType = this.editProposal.get('payTillAge').value;
            }
            const wholeData = {
                whole_life_opted: true,
                premium_term: this.premiumTermVal || this.quotesInitialInfo['premium_term'],
                premium_payment_type: this.premiumPPtType['premiumPaymentType']
            };


            //     const mergedObjectInfo: any = {

            //     lifeassured: Object.assign({} )
            // };

            this.mergedObject = wholeData;

        } else {

            this.setPayTillAge();
            if (this.editProposal.get('payTillAge').value) {

                this.premiumPPtType = this.editProposal.get('payTillAge').value;
            }
            if (typeof (this.editProposal.get('policyTerm').value) === 'number') {
                this.wholeLifeBoolean = false;
            } else {
                this.wholeLifeBoolean = true;
            }

            const data = {

                coverage_age: this.editProposal.get('policyTerm').value,
                whole_life_opted: this.wholeLifeBoolean,
                premium_term: this.premiumTermVal || this.quotesInitialInfo['premium_term'],
                premium_payment_type: this.premiumPPtType['premiumPaymentType']

            };


            this.mergedObject = data;
        }


        /*
            * If coverage age value avail in system
        */


        this.apiService.updateProposal(policyTermUrl, proposalId, uuid, queryParamsURL, this.mergedObject).subscribe(res => {
            this.policyTermRes = res;
            // this.limitedPayList = res['response']['available_plans_set'];
            // this.quotesInitialInfo = res['response'];
            this.limitedPayList = res['response']['available_plans_set'];
            this.setPayTillAge(res['response']);
            this.getRiderFormControl();
            this.getRiderInfo();
            this.setOptedRider();


        });

        // }
    }

    payTillAgeInvoked(evnt: any) {

        const retrievedEvent = evnt.value;

        if (retrievedEvent['value'] === 1) {

            this.premiumTermVal = this.quotesInitialInfo['policy_term'];
            this.premiumPaymentTypeToSend = evnt['value']['premiumPaymentType'];
            /**
             * On proposal response, feed dob and get date
             */
            // const ageObtained =  this.sharedApi.getAgeInyears(  this.proposalRes['lifeassured']['dob']);

        }
        else if (retrievedEvent['value'] === 60) {

            this.premiumTermVal =
                retrievedEvent['value'] - (this.sharedData.getAgeInyears(this.quotesInitialInfo['lifeassured']['dob']));
            if (this.premiumTermVal < 0) {
                this.premiumTermVal = 0;
            }
            this.premiumPaymentTypeToSend = evnt['value']['premiumPaymentType'];


        }
        else {
            this.premiumTermVal = retrievedEvent['value'];
            this.premiumPaymentTypeToSend = evnt['value']['premiumPaymentType'];
        }



        const paytillAgeData = {

            premium_term: this.premiumTermVal,
            premium_payment_type: this.premiumPaymentTypeToSend

        };


        this.apiService.updateProposal(
            this.apiUrl['apiV2LifeProposal'], this.proposalId, this.uuid,
            this.apiUrl['update_proposal'], paytillAgeData).subscribe(res => {
                this.policyTermRes = res;
                this.sharedDataService.setProposalData(this.policyTermRes['response']);
                this.sharedDataService.initiateQuotation(this.proposalId, this.uuid);


            });
    }

    /**
   * setting pay till age as per response dat
   */

    setPayTillAge( dataObtained ?: any) {

        if (dataObtained){

            this.quotesInitialInfo = dataObtained;
        }

        if (this.quotesInitialInfo['available_plans_set']) {

            this.limitedPayList = this.quotesInitialInfo['available_plans_set'];

        } else {
            this.limitedPayList = this.editProposalModalJson['payTillAge']['limitedPayList'];
        }

        this.limitedPayList.forEach((element) => {



            if (element['premiumPaymentType'] === this.quotesInitialInfo['premium_payment_type']) {

                /**
                  * ToDos
                */

                if (this.quotesInitialInfo['premium_payment_type'] === 2) {

                    this.editProposal.patchValue({ payTillAge: element });
                }

                if (this.quotesInitialInfo['premium_payment_type'] === 4) {

                    this.editProposal.patchValue({ payTillAge: element });
                }


                /**
                 * Check for regular case as premum payment type is same for 5, 7, 10
                 */
                if (this.quotesInitialInfo['premium_term'] === element['value']) {

                    this.editProposal.patchValue({ payTillAge: element });
                }


            }


        });

    }


    getRiderInfo() {



        if (this.quotesInitialInfo['config']['rider_config'] && this.quotesInitialInfo['config']['rider_config'].length > 0) {



            /**
             * creating rider control
             */


            let riderSumAssuredListInfo = [];
            if (this.quotesInitialInfo['config']['rider_config'].length > 0) {



                this.quotesInitialInfo['config']['rider_config'].forEach((riderElement, riderIndex) => {


                    let riderAmount = [];
                    this.riderSumAssuredList = [];
                    if (riderElement) {

                        const minSumAssured = riderElement['min_sumassured'];
                        const maxSumAssured = riderElement['max_sumassured'];
                        const incrementalVal = riderElement['sumassured_slab'];

                        for (let riderAmnt = minSumAssured; riderAmnt <= maxSumAssured; riderAmnt += incrementalVal) {

                            /**
                             * Setting rider sum insured value as per rider and push to quotes list
                             */

                            this.riderSumAssuredList.push({ id: riderAmnt, value: riderAmnt });
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderSumAssuredList'] = this.riderSumAssuredList;




                        }

                        if (this.quotesInitialInfo['opted_rider'] && this.quotesInitialInfo['opted_rider'].length > 0){
                            this.setOptedRider();
                        } else {
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isDisable'] = false
                        }


                    }


                    /**
                         * check if value exist in rider codnfig or not
                         * if vlaue has been added then check on the basis of rider premium
                         * if rider premium has not been added then in that case  make value default set to false as it can be
                         * added else make it true
                         */




                });


            }



        }

    }


    setOptedRider() {
        // this.quotesInitialInfo['config']['rider_config'].forEach((riderElement, riderIndex) => {

            // if (this.quotesInitialInfo['opted_rider'] && this.quotesInitialInfo['opted_rider'].length > 0) {
                this.quotesInitialInfo['config']['rider_config'].forEach((riderElement, riderIndex) => {

                    let booleanValue = false;
                    let basePremium: number;

                this.quotesInitialInfo['opted_rider'].forEach((incomingRiderElement, incomingRiderIndex) => {

                    /**
                     * Looping agian to read rider code otherwise index will not going to be increased
                     */
                    if (riderElement['rider_code'] ===    incomingRiderElement['rider_code_readonly']) {
                        booleanValue = true;
                        basePremium = incomingRiderElement['base_premium']


                    }




                    });


                    if (booleanValue) {
                        /**
                         * patching value to particualr sum assured
                         */
                        //this.editProposal.patchValue({riderSumAssured : incomingRiderElement['benefit'] });
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = true;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isDisable'] = true;


                        if (basePremium) {

                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderPremiumTax'] = basePremium;
                            // this.editProposal.get('addRiderDetails')['controls'][incomingRiderIndex]['controls']['riderSumAssuredInfo'].disable();
                        }



                        /**
                         * check if value exit in add ons
                         */



                    }
                    else {
                        this.quotesInitialInfo['config']['rider_config'][riderIndex ]['isEditActivated'] = false;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isDisable'] = false;
                    }

                });


                //  });


            // }

        // });

    }


    /**
     * Creating form control
     */


    createRiderCtrl(): FormGroup {

        /**
         * Assigning key same as backend to avoid matching key name
         */

        return this.formbuild.group({
            id: [],
            riderSumAssuredInfo: []

        });

    }

    /**
   * creating form control
   */

    getRiderFormControl() {


        if (this.quotesInitialInfo['config']['rider_config'] && this.quotesInitialInfo['config']['rider_config'].length > 0) {

            for (let i = 0; i < this.quotesInitialInfo['config']['rider_config'].length; i++) {

                this.addRiderInfoDetails();
            }


        }


        this.quotesInitialInfo['opted_rider'].forEach((riderConfigData, index) => {



            const exisitingPolicyElement = {
                id: riderConfigData.id,
                riderSumAssuredInfo: riderConfigData.sum_assured,

            };

            /**
             * Check for opted rider index and assign to current index
             *
             */
            if (this.quotesInitialInfo['config'] && this.quotesInitialInfo['config']['rider_config'] && this.quotesInitialInfo['config']['rider_config'].length > 0){

                this.quotesInitialInfo['config']['rider_config'].forEach((element, riderIndx) => {

                    if (element['rider_code'] ===    riderConfigData['rider_code_readonly']) {

                        if (this.editProposal.get('addRiderDetails').get(index.toString())) {

                            if (this.quotesInitialInfo['config'] && this.quotesInitialInfo['config']['rider_config'] && this.quotesInitialInfo['config']['rider_config'].length > 0) {


                                this.quotesInitialInfo['config']['rider_config'][riderIndx]['riderId'] = riderConfigData.id;
                            }

                            this.editProposal.get('addRiderDetails').get(riderIndx.toString()).patchValue(exisitingPolicyElement);
                            this.editProposal.get('addRiderDetails')['controls'][riderIndx]['controls']['riderSumAssuredInfo'].disable();
                        }

                    }

                });

            }


        });

    }

    addRiderInfoDetails() {

        (this.editProposal.controls['addRiderDetails'] as FormArray).push(this.createRiderCtrl());

        // this.existingPolicyValidation();


    }

    /**
     * Rider premium updation
     */
    editButtonInvoked(rider, riderIndex) {
        this.editProposal.get('addRiderDetails')['controls'][riderIndex]['controls']['riderSumAssuredInfo'].enable();

        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = true;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isDisable'] = false;
        // this.quotesInitialInfo['config']['rider_config'][riderIndex]['config']['rider_config'][viewIndex]['isUpdateActivate'] = true;

    }



    /**
     * update  riders on basis of edit click
     */

    updateRiderSumAssured(rider, riderIndex) {

        this.riderButonInvoked(rider, riderIndex);
    }

    removeRiderPremium(rider, riderIndex) {

        // this.riderButonInvoked(rider, riderIndex);


        const data = {

            id: rider['riderId'] || '',
            deleted: true

        }

        const riderData = {

            opted_rider: [data]

        };
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = true;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;

        this.apiService.updateProposal(
            this.apiUrl['apiV2LifeProposal'],
            this.proposalId, this.uuid, this.apiUrl['update_proposal'], riderData).subscribe(riderRes => {

                if (riderRes) {

                    /**
                     * collecting add ons id from update proposal adn assign bacck it in rider config
                     */
                    let riderResponse = riderRes['response'];

                    // riderResponse['opted_rider'].forEach((updatedElement, UpdatedIndex) => {
                    //     if (updatedElement) {
                    //         this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderId'] = updatedElement['id'];
                    //     }
                    // });

                    const insurer = this.apiUrl['insurer'] + this.quotesInitialInfo['config']['insurer'];
                    const product = this.apiUrl['product'] + this.quotesInitialInfo['config']['product_code'];


                    this.sharedData.getRecalculatePremium(this.proposalId, this.uuid, this.apiUrl['life_v2'], this.apiUrl['reCalculatePremium'], insurer, product,).subscribe(reCalRes => {
                        const reCalResponse = reCalRes;
                        if (reCalResponse) {
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderId'] = '';

                            if (this.editProposal.get('addRiderDetails').value) {

                                this.editProposal.get('addRiderDetails').value.forEach((element, arrayIndx) => {

                                    if (arrayIndx === riderIndex) {
                                        element['riderSumAssuredInfo'] = null;
                                    }
                                });
                            }

                            this.riderSumAssuredList = [];
                            const incrementalVal = this.quotesInitialInfo['config']['rider_config'][riderIndex]['sumassured_slab'];
                            this.editProposal.get('addRiderDetails')['controls'][riderIndex]['controls']['riderSumAssuredInfo']['value'] = null;
                            this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderSumAssuredList'] = [];
                            this.editProposal.get('addRiderDetails')['controls'][riderIndex]['controls']['riderSumAssuredInfo'].enable();
                            for (let riderAmnt =this.quotesInitialInfo['config']['rider_config'][riderIndex]['min_sumassured']; riderAmnt <= this.quotesInitialInfo['config']['rider_config'][riderIndex]['max_sumassured']; riderAmnt += incrementalVal) {

                                this.riderSumAssuredList.push({ id: riderAmnt, value: riderAmnt });
                                this.quotesInitialInfo['config']['rider_config'][riderIndex]['riderSumAssuredList'] = this.riderSumAssuredList;

                            }
                            /**
                             * patching value to systemc
                             */


                        }

                    });


                }

            });



    }


    riderButonInvoked(rider, riderIndex) {

        /**
         * case 1 :- Invoke update proposal
         * case 2 :- on sucess , then recalculate quotation
         * Ask sir as, it is not picking for single index
         * temp solution
         */
        let sumInsurdInfo;
        this.isSumInsuredError = false;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = false;
        this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = true;


        this.editProposal.get('addRiderDetails').value.forEach((riderDetail, riderIndexInfo) => {

            if (riderIndexInfo === riderIndex) {
                sumInsurdInfo = riderDetail['riderSumAssuredInfo']
            }
        });

        this.sharedDataService.setRiderData(rider);

        /**
         * check for sum insured info
         */

        if (sumInsurdInfo) {

            const data = {

                id: rider['riderId'] || '',
                rider_code: rider['rider_code'],
                sum_assured: sumInsurdInfo || ''

            }

            const riderData = {

                opted_rider: [data]

            };


            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid, this.apiUrl['update_proposal'], riderData).subscribe(riderRes => {

                    if (riderRes) {
                        this.isDisplayedError = false;
                        /**
                         * collecting add ons id from update proposal adn assign bacck it in rider config
                         */
                        let riderResponse = riderRes['response'];

                        riderResponse['opted_rider'].forEach((updatedElement, UpdatedIndex) => {
                            if (updatedElement) {
                                this.quotesInitialInfo['config']['rider_config'].forEach((incomingRiderElement, incomingRiderIndex) => {

                                    if (incomingRiderElement['rider_code'] === updatedElement['rider_code_readonly']) {

                                        this.quotesInitialInfo['config']['rider_config'][incomingRiderIndex]['riderId'] = updatedElement['id'];
                                    }

                                });

                            }
                        });

                        const insurer = this.apiUrl['insurer'] + this.quotesInitialInfo['config']['insurer'];
                        const product = this.apiUrl['product'] + this.quotesInitialInfo['config']['product_code'];


                        this.sharedData.getRecalculatePremium(this.proposalId, this.uuid, this.apiUrl['life_v2'], this.apiUrl['reCalculatePremium'], insurer, product,).subscribe(reCalRes => {
                            const reCalResponse = reCalRes;
                            if (reCalResponse) {
                                this.quotesInitialInfo['config']['rider_config'][riderIndex]['isEditActivated'] = true;
                                this.quotesInitialInfo['config']['rider_config'][riderIndex]['isUpdateActivate'] = false;
                                this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;


                                /**
                                 * patching value to systemc
                                 */
                                this.editProposal.get('addRiderDetails')['controls'][riderIndex]['controls']['riderSumAssuredInfo'].disable();




                                /**
                                 * getting Rider Fremium
                                 */

                                if(reCalResponse && reCalResponse['riders'] && reCalResponse['riders'].length > 0){

                                    reCalResponse['riders'].forEach((updatedRider, updatedIndex) => {

                                        if (updatedRider) {

                                            this.quotesInitialInfo['config']['rider_config'].forEach((incomingRiderElement, incomingRiderIndex) => {
                                                if (incomingRiderElement['rider_code'] === updatedRider['rider']) {

                                                    this.quotesInitialInfo['config']['rider_config'][incomingRiderIndex]['riderPremiumTax'] = updatedRider['base_premium'].toString();
                                                   this.quotesInitialInfo['config']['rider_config'][incomingRiderIndex]['isSelectedIcon'] = true;
                                                   this.quotesInitialInfo['config']['rider_config'][incomingRiderIndex]['isEditActivated'] = true;
                                                }

                                            });





                                        }

                                    });
                                }

                            }

                        });


                    }

                });
        } else {
            this.isSumInsuredError = true;
            this.quotesInitialInfo['config']['rider_config'][riderIndex]['isLoaderinActiveState'] = false;

        }

        setTimeout(() => {
            this.isSumInsuredError = false;
        }, 5000);


    }





    ngOnInit() {
    }

    saveEditModalData(isvalid: boolean, e: any) {
        e.preventDefault();
        const editQuoteUrl = this.apiUrl['apiV2LifeProposal'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['update_proposal'];
        let rider = null;
        this.sharedDataService.setRiderData(rider);


        // Check edit quote form status
        if (isvalid) {

            this.isLoaderActivated = true;

            const annualIncomeTemp = this.editProposal.get('annualIncome').value;
            if (typeof annualIncomeTemp !== 'number' && (annualIncomeTemp).indexOf(',') > -1) {
                this.annualIncomeData = (this.editProposal.get('annualIncome').value).replace(/,\s?/g, '');
            } else {
                this.annualIncomeData = this.editProposal.get('annualIncome').value;
            }

            if (this.quotesInitialInfo['product_type'] === this.productConf['savingProductType']) {


                let premiumAmount = this.editProposal.get('premiumAmnt').value;

                if (typeof premiumAmount !== 'number' && (premiumAmount).indexOf(',') > -1) {

                    this.premiumAmountVal = (this.editProposal.get('premiumAmnt').value).replace(/,\s?/g, '');

                } else {

                    this.premiumAmountVal = this.editProposal.get('premiumAmnt').value;

                }


                const data = {
                    base_premium: this.premiumAmountVal,
                    premium_term: this.editProposal.get('payFor').value,
                    policy_term: this.editProposal.get('withdrawFor').value,
                    annual_income: this.annualIncomeData,
                    lifeassured: {
                        dob: this.datePipe.transform(new Date(this.editProposal.get('dob').value), 'yyyy-MM-dd'),
                        annual_income: this.annualIncomeData,
                    },

                    premium_installment_type: this.editProposal.get('paymentFrequency').value,
                };

                this.mergedObject = data;

            } else {


                const sumAssuredTemp = this.editProposal.get('sumAssured').value;
                if (typeof sumAssuredTemp !== 'number' && (sumAssuredTemp).indexOf(',') > -1) {
                    this.sumAssuredValue = (this.editProposal.get('sumAssured').value).replace(/,\s?/g, '');
                } else {
                    this.sumAssuredValue = this.editProposal.get('sumAssured').value;
                }



                /**
                 * Policy term value
                 */

                const ageObtained = this.sharedData.getAgeInyears(new Date(this.dobCal));
                const policyValObtained = this.editProposal.get('policyTerm').value - ageObtained;
                // const policydata = {
                //     policy_term: policyValObtained,
                //     premium_term: policyValObtained
                // };

                if (this.editProposal.get('payTillAge').value['value'] === 60) {

                    this.premiumTermVal =
                        this.editProposal.get('payTillAge').value['value'] - (this.sharedData.getAgeInyears(this.quotesInitialInfo['lifeassured']['dob']));
                    if (this.premiumTermVal < 0) {
                        this.premiumTermVal = 0;
                    }
                    this.premiumPaymentTypeToSend = this.premiumTermVal;


                } else {
                    this.premiumPaymentTypeToSend = this.editProposal.get('payTillAge').value['value']
                }
                let wholeLife;
                let data;
                /**
                 * check value has whole life
                 */

                if (this.editProposal.get('policyTerm').value === this.editProposalModalJson['whole-life']) {
                    wholeLife = true;
                }

                if (wholeLife === true){


                data = {

                    whole_life_opted: wholeLife,
                    sum_assured: this.sumAssuredValue,
                    premium_payment_type: this.editProposal.get('payTillAge').value['premiumPaymentType'],
                    premium_term: this.premiumPaymentTypeToSend,
                    lifeassured: {
                        dob: this.datePipe.transform(new Date(this.editProposal.get('dob').value), 'yyyy-MM-dd'),
                        annual_income: this.annualIncomeData,
                    },

                    premium_installment_type: this.editProposal.get('paymentFrequency').value,
                };
                } else {

                    data = {

                        coverage_age: this.editProposal.get('policyTerm').value,
                        sum_assured: this.sumAssuredValue,
                        premium_payment_type: this.editProposal.get('payTillAge').value['premiumPaymentType'],
                        premium_term: this.premiumPaymentTypeToSend,
                        lifeassured: {
                            dob: this.datePipe.transform(new Date(this.editProposal.get('dob').value), 'yyyy-MM-dd'),
                            annual_income: this.annualIncomeData,
                        },

                        premium_installment_type: this.editProposal.get('paymentFrequency').value,
                    };
                }

                this.mergedObject = data;

                /**
                 * Append id to Rider info if it isa available
                 */


                // const riderData = {

                //     opted_rider: this.editProposal.get('addRiderDetails').value

                // };

                // this.mergedObject = Object.assign({}, this.mergedObject, riderData);

                if (this.editProposal.get('policyTerm').value === this.editProposalModalJson['whole-life']) {

                    const wholeData = {
                        whole_life_opted: true
                    };

                    this.mergedObject = Object.assign({}, this.mergedObject, wholeData);

                } else {
                    const covData = {

                        coverage_age: this.editProposal.get('policyTerm').value,
                        whole_life_opted: false
                    };

                    this.mergedObject = Object.assign({}, this.mergedObject, covData);
                }
            }




            this.apiService.updateProposal(editQuoteUrl, proposalId, uuid, queryParamsURL, this.mergedObject).subscribe(res => {
                this.editPropsalModalResp = res['response'];
                this.sharedData.callMethodOfSecondComponent( res['response']);
                if (this.editPropsalModalResp) {


                    // if (this.activatedRoute.component['name'] === this.productType['biComponenthandlerClass']) {
                    // tslint:disable-next-line: no-shadowed-variable
                    this.sharedData.getRecalculatedPremium(this.proposalId, this.uuid).subscribe(updatedRes => {
                        if (updatedRes) {

                            this.isCoverageAgeError = true;
                            this.isDisplayedError = false;
                            const dataToSend = {
                                proposalResponse: this.editPropsalModalResp,
                                updatedPremiumOnRecal: updatedRes
                            };

                            this.apiService.setModalInfo(false);
                            this.isLoaderActivated = false;
                            this.dialogRef.close({ event: 'close', data: dataToSend });
                        }
                        location.reload()

                    });




                    // }

                    // this.initiateQuote();
                    // this.dialogRef.close({ event: 'close', data: this.editPropsalModalResp });
                    // }

                }
            });
            
        }

    }



    /**
     * on modal cancel click
     */

    cancelEdit() {

        // this.dialogRef.close({ event: 'close' });
        this.sharedData.getProposalInfo(this.proposalId, this.uuid).subscribe(res => {
            if (res) {
                this.sharedData.callMethodForProposalComponent(res);

                const dataToSend = {
                    proposalResponse: res,
                };
                this.apiService.setModalInfo(false);
                this.dialogRef.close({ event: 'close', data: dataToSend });
            }

        });



    }






}
